// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/school-meets-work/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const schoolMeetsWorkDE: PageEntry = {
  id: "post.school-meets-work",
  locale: "de",
  slug: "school-meets-work",
  seo: {
    title: "School meets work | Dietz GmbH",
    description: "School meets work",
  },
  type: "post",
  h1: "School meets work",
  blocks: [
    { kind: "heading", level: 2, text: "School meets work" },
    { kind: "paragraph", text: "„School meets work“ – Ein sehr gelungener Aktionstag, der bereits im vergangen Monat in unserem Hause stattfand. Wir haben eine Schulklasse eingeladen in verschiedene Berufsfelder bei der Dietz GmbH hineinzuschnuppern. Die Schüler*innen durften sich auch direkt selbst in der Praxis ausprobieren ." },
    { kind: "paragraph", text: "Auch Du hast Lust hinter die Kulissen der Dietz GmbH zu blicken und erste Kontakte zu knüpfen? Dann absolviere doch ein Praktikum bei uns. Wir bieten dir sogar die Möglichkeit gleich mehrere Berufsfelder kennenzulernen. Das klingt spannend?" },
    { kind: "paragraph", text: "➡️ Dann melde dich rechtzeitig bei uns: ruf gerne bei uns durch ( +49 (0) 9568 9442-0 ) oder schreibe uns eine E-Mail ( karriere@dietz.eu )." }
  ],
};
